export default __webpack_public_path__ + "i18n/translations/translation-mr.cd711062.json";